import { motion } from 'framer-motion';
import { Users, Award, Star, ShieldCheck } from 'lucide-react';

export function SocialProofStrip() {
  const stats = [
    { icon: Users, label: '5.000+ Estudantes Ativos' },
    { icon: Award, label: '+85% de Taxa de Aprovação' },
    { icon: Star, label: '4.9/5 Avaliação média' },
    { icon: ShieldCheck, label: 'Garantia de 7 dias ou seu dinheiro de volta' },
  ];

  return (
    <div className="bg-muted/50 border-y py-6 mt-12">
      <div className="container overflow-hidden">
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center md:justify-between items-center gap-8 md:gap-4"
        >
          {stats.map((stat, i) => (
            <div key={i} className="flex items-center gap-2 text-muted-foreground whitespace-nowrap">
              <stat.icon className="h-4 w-4 text-primary" />
              <span className="text-xs md:text-sm font-medium tracking-tight uppercase">{stat.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
